import type { AxiosResponse } from 'axios';

interface ApiEnvelope<T> {
  success: boolean;
  message: string;
  data?: T;
  error?: string;
}

/** Unwraps `{ success, data }` envelopes or returns raw body for legacy responses. */
export function unwrapApiResponse<T>(response: AxiosResponse<ApiEnvelope<T> | T>): T {
  const body = response.data;
  if (body && typeof body === 'object' && 'success' in body && (body as ApiEnvelope<T>).data !== undefined) {
    return (body as ApiEnvelope<T>).data as T;
  }
  return body as T;
}
